/** Explicit negotiation avoids extending strict legacy request bodies. */
export const RECOMMENDATION_ATTRIBUTION_CAPABILITY = "rq-attribution-v1";
export const RECOMMENDATION_SCHEMA_VERSION = 1;
export const RECOMMENDATION_SURFACES = ["build_week", "suggest_one", "swap"] as const;
export const RECOMMENDATION_TRIGGERS = ["initial", "user_refresh", "feedback_refresh", "review"] as const;
export const RECOMMENDATION_TEMPORARY_REASONS = ["not_now", "too_much_work_today", "missing_ingredients"] as const;
export const RECOMMENDATION_ENVIRONMENTS = ["local", "staging", "production", "unknown"] as const;
export type RecommendationSurface = typeof RECOMMENDATION_SURFACES[number];
export type RecommendationTrigger = typeof RECOMMENDATION_TRIGGERS[number];
export type RecommendationTemporaryReason = typeof RECOMMENDATION_TEMPORARY_REASONS[number];

export interface RecommendationRequestIdentity {
  attemptId: string;
  decisionId: string;
  surface: RecommendationSurface;
  trigger: RecommendationTrigger;
}

/** Only an explicit server acknowledgment selects the durable emitter. */
export interface RecommendationAttributionReceipt extends RecommendationRequestIdentity {
  capability: typeof RECOMMENDATION_ATTRIBUTION_CAPABILITY;
  schemaVersion: typeof RECOMMENDATION_SCHEMA_VERSION;
}

/** The API resolves recommendation identity from the actor's persisted slot. */
export interface RecommendationOutcomeContext {
  operationId: string;
  mealPlanId: string;
  mealSlotId: string;
}
export interface RecommendationOutcomeReceipt {
  capability: typeof RECOMMENDATION_ATTRIBUTION_CAPABILITY;
  schemaVersion: typeof RECOMMENDATION_SCHEMA_VERSION;
  operationId: string;
  replayed: boolean;
}
